// extracted by mini-css-extract-plugin
module.exports = {"Input":"EditLabel_Input__1kRwN","InputArea":"EditLabel_InputArea__25EMY","Button":"EditLabel_Button__2LSoM"};